// This is a polyfill for Math.pow that supports BigInts

Math.pow = function (base, exponent) {
  const baseType = typeof base;
  const exponentType = typeof exponent;

  // Convert inputs to BigInt if any of them is a BigInt
  if (baseType === 'bigint' || exponentType === 'bigint') {
    base = BigInt(base)
    exponent = BigInt(exponent)
    return powBigInt(base, exponent)
  } else {
    // Convert to Number to handle standard number inputs
    base = Number(base)
    exponent = Number(exponent)
    return powNumber(base, exponent)
  }
}

function powBigInt(base, exponent) {
  if (exponent === 0n) return 1n
  let result = base
  for (let i = 1n; i < (exponent < 0n ? -exponent : exponent); i++) {
    result *= base;
  }
  return exponent < 0n ? 1n / result : result;
}

function powNumber(base, exponent) {
  if (exponent === 0) return 1
  let result = base
  for (let i = 1; i < Math.abs(exponent); i++) {
    result *= base
  }
  return exponent < 0 ? 1 / result : result
}
